





















import Vue, { PropType } from 'vue'

import BasePanel from 'base/components/BasePanel.vue'
import { store } from 'base/store'
import { MessageChannel } from 'base/store/state.interface'

import { ChatService } from '../../chat/ChatService'
import ChannelListFilter, { ChannelListFilterSettings } from './ChannelListFilter.vue'
import ChannelListSection from './ChannelListSection.vue'

export interface ChannelListMessageChannel extends MessageChannel {
  numUnreadMessages: string | number
}

export default Vue.extend({
  components: {
    BasePanel,
    ChannelListSection,
    ChannelListFilter
  },
  props: {
    channels: {
      type: Array as PropType<MessageChannel[]>,
      required: true
    },
    favoritedChannelIds: {
      type: Array as PropType<number[]>,
      required: true
    }
  },
  data() {
    return {
      filter: '',
      unreadOnly: false
    }
  },
  computed: {
    adjustedChannels(): ChannelListMessageChannel {
      const result: ChannelListMessageChannel[] = []
      const channels = this.channels
      const numChannels = channels.length
      let i = 0

      for (; i < numChannels; i++) {
        const channel: ChannelListMessageChannel = channels[i]
        channel.numUnreadMessages = ChatService.getNumUnreadMessagesInChannel(channel)
        result.push(channel)
      }

      return result
    },
    hasActiveFilters() {
      return !!this.filter || this.unreadOnly
    },
    channelTypes(): MessageChannel['foreign_type'][] {
      const channelTypes: MessageChannel['foreign_type'][] = this.filteredChannels.map((channel: MessageChannel) => channel.foreign_type)
      return [...new Set(channelTypes)].sort() // Remove duplicates
    },
    filteredChannels(): MessageChannel[] {
      const channels = this.adjustedChannels

      const filterStr = this.filter.toLowerCase().trim()
      const unreadOnly = this.unreadOnly

      if (!this.hasActiveFilters) {
        return channels
      }

      return channels.filter(channel => {
        let match = true

        if (match && filterStr) {
          match = match && (channel.title.toLowerCase() + channel.description.toLowerCase()).includes(filterStr)
        }

        if (match && unreadOnly) {
          match = match && (parseInt(channel.numUnreadMessages, 10) > 0)
        }

        return match
      })
    },
    canCreateChannel(): boolean {
      const access = store.state.user.access
      if (!access.message_channel || !access.message_channel_actions) return false

      return access.message_channel_actions.edit_all
    }
  },
  methods: {
    channelsForType(channelType: string): MessageChannel[] {
      return this.filteredChannels.filter(channel => channel.foreign_type === channelType)
    },
    filterChanged(filter: ChannelListFilterSettings) {
      this.filter = filter.filterStr
      this.unreadOnly = filter.unreadOnly
    }
  }
})
